import { render, staticRenderFns } from "./MonthlyTaxAmbank.vue?vue&type=template&id=4b0de8df"
import script from "./MonthlyTaxAmbank.vue?vue&type=script&lang=js"
export * from "./MonthlyTaxAmbank.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports